import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTES } from '../utils/constant';
import url from '../utils/url';
import { storyFeedLink } from '../utils/storyFeedLink';
import { unsubscribeStoryId } from '../unsubscribe/link';

// All event entry points share the same history/snapshot contract. Switching
// sections must not turn a return to the originating opinion into a fresh feed.
export default function useStoryNavigation({ storyId, title, reactionId = 0,
  activeSection = null, detailArea = 'all', onLeaveFeed, profileUsername, entry = null }) {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const username = profileUsername || params.username;
  const savedReturn = location.state?.storyFeedReturn;
  const feedReturn = entry === 'unsubscribe' ? { storyId, entry, unsubscribeStoryId: unsubscribeStoryId(location.search) }
    : reactionId > 0
    ? { storyId, reactionId, ...(username ? { state: { profileUsername: username } } : {}) }
    : Number(savedReturn?.storyId) === Number(storyId) ? savedReturn : null;
  const searchReturn = location.state?.searchReturn;
  const searchPath = searchReturn && location.state?.from;
  const returnLink = storyFeedLink({ storyId, title, feedReturn, profileUsername: username });
  const { to: returnPath, state: returnState } = returnLink;

  const sectionLink = (section, route) => ({
    to: activeSection === section ? returnPath : url(`${APP_ROUTES.POST}/${storyId}/${route}`)
      + (['country', 'friends'].includes(detailArea) ? `?area=${detailArea}` : ''),
    state: activeSection === section ? returnState
      : { from: searchPath || returnPath, storyFeedReturn: feedReturn, storyPreview: { id: storyId, title }, ...(searchPath ? { searchReturn } : {}) },
    onClick: event => {
      if (!onLeaveFeed || activeSection || event.defaultPrevented || event.button !== 0
        || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
      // Capture only when leaving, after local likes/reader changes. History
      // carries an opaque token; the account-scoped feed stays in memory.
      const state = onLeaveFeed();
      if (!state) return;
      event.preventDefault();
      navigate(returnPath, { replace: true, state });
      navigate(url(`${APP_ROUTES.POST}/${storyId}/${route}`), { state: {
        from: returnPath, storyFeedReturn: { ...feedReturn, state }, storyPreview: { id: storyId, title },
      } });
    },
  });
  return { returnLink, sectionLink };
}
